import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Public/Header';
import Footer from '../components/Public/Footer';
import ConsentBanner from '../components/Public/ConsentBanner';
import HeroSection from '../components/Public/HeroSection';
import FeatureGrid from '../components/Public/FeatureGrid';
import HowItWorks from '../components/Public/HowItWorks';
import SecurityCallout from '../components/Public/SecurityCallout';
import CTASection from '../components/Public/CTASection';
import FAQ from '../components/Public/FAQ';
import { MAIN_FAQ, SITE } from '../config/site';

export default function MainPage() {
  useEffect(() => {
    // Smooth scroll to section if hash is present
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: MAIN_FAQ.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: `https://${SITE.domain}`,
    logo: `https://${SITE.domain}/logo512.png`,
    contactPoint: {
      '@type': 'ContactPoint',
      email: SITE.supportEmail,
      contactType: 'customer support',
    },
  };

  return (
    <>
      <Helmet>
        <title>{SITE.name}</title>
        <meta
          name="description"
          content="Upload recordings or auto-join Zoom/Teams to capture transcripts, summaries, and action items. Multi-organization support with calendar sync."
        />
        <link rel="canonical" href={`https://${SITE.domain}/`} />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <HeroSection />
          <FeatureGrid />
          <HowItWorks />
          <SecurityCallout />
          <CTASection
            title="See Our Pricing"
            subtitle="Flexible plans for teams of all sizes"
            buttonText="View Pricing"
            to="/pricing"
          />
          <FAQ faqs={MAIN_FAQ} />
        </Box>
        <Footer />
        <ConsentBanner />
      </Box>
    </>
  );
}
